import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalPendapatan: 0,
    totalProduk: 0,
    transaksiBulanIni: 0,
    pengunjung: 0
  });

  useEffect(() => {
    // Data dummy
    setStats({
      totalPendapatan: 125000000,
      totalProduk: 15,
      transaksiBulanIni: 47,
      pengunjung: 1234
    });
  }, []);

  const StatCard = ({ title, value, icon, color, prefix = '' }) => (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
      <div className="flex items-center">
        <div className={`p-3 rounded-xl ${color} text-white`}>
          <span className="text-2xl">{icon}</span>
        </div>
        <div className="ml-4">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900">
            {prefix}{typeof value === 'number' ? value.toLocaleString('id-ID') : value}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600">Selamat datang kembali, {user?.name}!</p>
        </div>
        <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-lg">
          {new Date().toLocaleDateString('id-ID', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          title="Total Pendapatan"
          value={stats.totalPendapatan}
          icon="💰"
          color="bg-green-500"
          prefix="Rp "
        />
        <StatCard
          title="Total Produk"
          value={stats.totalProduk}
          icon="🛍️"
          color="bg-blue-500"
        />
        <StatCard
          title="Transaksi Bulan Ini"
          value={stats.transaksiBulanIni}
          icon="📊"
          color="bg-purple-500"
        />
        <StatCard
          title="Pengunjung"
          value={stats.pengunjung}
          icon="👥"
          color="bg-orange-500"
        />
      </div>

      {/* Quick Actions & Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Quick Actions */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
          <div className="space-y-3">
            <button className="w-full text-left p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-blue-500 hover:bg-blue-50 transition-colors flex items-center">
              <span className="text-2xl mr-3">📝</span>
              <div>
                <p className="font-medium text-gray-900">Tambah Produk Baru</p>
                <p className="text-sm text-gray-500">Tambahkan produk UMKM baru</p>
              </div>
            </button>
            <button className="w-full text-left p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-green-500 hover:bg-green-50 transition-colors flex items-center">
              <span className="text-2xl mr-3">💰</span>
              <div>
                <p className="font-medium text-gray-900">Input Transaksi</p>
                <p className="text-sm text-gray-500">Catat pemasukan/pengeluaran</p>
              </div>
            </button>
            <button className="w-full text-left p-4 rounded-lg border-2 border-dashed border-gray-300 hover:border-purple-500 hover:bg-purple-50 transition-colors flex items-center">
              <span className="text-2xl mr-3">📢</span>
              <div>
                <p className="font-medium text-gray-900">Buat Pengumuman</p>
                <p className="text-sm text-gray-500">Bagikan informasi terbaru</p>
              </div>
            </button>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:col-span-2">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Aktivitas Terbaru</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-green-50 rounded-lg border border-green-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 mr-4">
                  ✓
                </div>
                <div>
                  <p className="font-medium text-gray-900">Transaksi Penjualan</p>
                  <p className="text-sm text-gray-500">Keripik Singkong - Rp 150.000</p>
                </div>
              </div>
              <span className="text-sm text-gray-500 bg-white px-2 py-1 rounded">2 jam lalu</span>
            </div>
            
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-4">
                  🛍️
                </div>
                <div>
                  <p className="font-medium text-gray-900">Produk Baru</p>
                  <p className="text-sm text-gray-500">Madu Hutan ditambahkan</p>
                </div>
              </div>
              <span className="text-sm text-gray-500 bg-white px-2 py-1 rounded">5 jam lalu</span>
            </div>

            <div className="flex items-center justify-between p-4 bg-purple-50 rounded-lg border border-purple-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 mr-4">
                  📢
                </div>
                <div>
                  <p className="font-medium text-gray-900">Pengumuman Baru</p>
                  <p className="text-sm text-gray-500">Pelatihan pengolahan hasil pertanian</p>
                </div>
              </div>
              <span className="text-sm text-gray-500 bg-white px-2 py-1 rounded">1 hari lalu</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;